import {Component, Input} from '@angular/core';

type Sizes = 'sm' | 'md' | 'lg' | 'cta' | 'xs' | 'normal' | 'big' | 'xl' | 'xxl' | 'xxxl';
@Component({
  selector: 'app-qeleo-icon',
  standalone: true,
  imports: [],
  templateUrl: './qeleo-icon.component.html',
  styleUrl: './qeleo-icon.component.scss'
})

export class QeleoIconComponent {
  @Input({required: true})
  iconName: string = "create";

  @Input()
  className?: string;

  @Input()
  size: Sizes = 'normal';

}
